// Service Worker Registration for PWA

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {

    if (!('serviceWorker' in navigator)) {
        return;
    }

    const publicUrl = new URL(
        process.env.PUBLIC_URL || '',
        window.location.href
    );

    if (publicUrl.origin !== window.location.origin) {
        return;
    }

    window.addEventListener('load', () => {

        const swUrl =
            `${process.env.PUBLIC_URL || ''}/service-worker.js`;

        if (isLocalhost) {

            checkValidServiceWorker(
                swUrl,
                config
            );

        } else {

            registerValidSW(
                swUrl,
                config
            );
        }
    });
}


// ============================================================
// Register Service Worker
// ============================================================

function registerValidSW(swUrl, config) {

    navigator.serviceWorker
        .register(swUrl, {
            updateViaCache: 'none'
        })
        .then((registration) => {

            // Check for an update immediately
            registration.update();

            registration.onupdatefound = () => {

                const installingWorker =
                    registration.installing;

                if (!installingWorker) {
                    return;
                }

                installingWorker.onstatechange = () => {

                    if (installingWorker.state === 'installed') {

                        if (navigator.serviceWorker.controller) {

                            console.log(
                                'New version detected. Updating application...'
                            );

                            if (config && config.onUpdate) {
                                config.onUpdate(registration);
                            }

                        } else {

                            console.log(
                                'Service Worker installed for the first time.'
                            );

                            if (config && config.onSuccess) {
                                config.onSuccess(registration);
                            }
                        }
                    }
                };
            };
        })
        .catch((error) => {

            console.error(
                'Error during service worker registration:',
                error
            );

        });
}


// ============================================================
// Localhost validation
// ============================================================

function checkValidServiceWorker(
    swUrl,
    config
) {

    fetch(swUrl, {
        headers: {
            'Service-Worker': 'script'
        }
    })
        .then((response) => {

            const contentType =
                response.headers.get(
                    'content-type'
                );

            if (
                response.status === 404 ||
                (
                    contentType !== null &&
                    !contentType.includes(
                        'javascript'
                    )
                )
            ) {

                navigator.serviceWorker.ready
                    .then((registration) => {

                        registration.unregister()
                            .then(() => {

                                window.location.reload();

                            });
                    });

            } else {

                registerValidSW(
                    swUrl,
                    config
                );
            }
        })
        .catch(() => {

            console.log(
                'No internet connection found. App is running in offline mode.'
            );
        });
}


// ============================================================
// Unregister
// ============================================================

export function unregister() {

    if ('serviceWorker' in navigator) {

        navigator.serviceWorker.ready
            .then((registration) => {

                registration.unregister();

            })
            .catch((error) => {

                console.error(
                    error.message
                );

            });
    }
}